var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M11.679.852C9.362.86 7.5 2.556 7.5 4.615v1.728H1.323C.593 6.343 0 6.87 0 7.52v4.707c0 .65.593 1.176 1.324 1.176h9.708c.73 0 1.324-.527 1.324-1.176V7.52c0-.65-.593-1.177-1.324-1.177H9.707V4.6c0-.97.874-1.777 1.966-1.787 1.104-.01 2.005.787 2.005 1.765V6.54c0 .326.295.589.662.589h.883c.367 0 .662-.263.662-.589V4.58c0-2.06-1.89-3.734-4.206-3.727z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpen);
export default __webpack_public_path__ + "static/media/icon_open.bdd71da7.svg";
export { ForwardRef as ReactComponent };